import { useEffect, useState } from 'react';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from '../../../shared/lib/firebase';
import type { SupportTicket } from '../lib/types';

export function useTicket(ticketId: string | undefined) {
  const [ticket, setTicket] = useState<SupportTicket | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ticketId) return;
    const unsub = onSnapshot(doc(db, 'support_tickets', ticketId), (snap) => {
      setTicket(snap.exists() ? ({ id: snap.id, ...(snap.data() as Omit<SupportTicket, 'id'>) }) : null);
      setLoading(false);
    }, (err) => { console.error('[useTicket]', err); setLoading(false); });
    return unsub;
  }, [ticketId]);

  async function markRead(): Promise<void> {
    if (!ticketId) return;
    await updateDoc(doc(db, 'support_tickets', ticketId), { unreadForOwner: false });
  }

  return { ticket, loading, markRead };
}
